import { IVideoMakerOpenerParams } from './useVideoMaker.types';
import {
  BasicGenericScenarioParams,
  EditScenarioFirstScreen,
  EditScenarioParams,
  EmptyGenericScenarioParams,
  Orientations,
  Scenarios,
  Templates,
  VideoScripts,
} from './videoMaker.types';

export function initializeVideoMakerOpenerParams({
  locale,
  metaSiteId,
  siteMediaToken,
  userId,
  extendedVideoMakerParams = {
    videoData: undefined,
    fileId: undefined,
    editScenarioFirstScreen: EditScenarioFirstScreen.Intro,
    templateData: { title: '', subTitle: '', videoUrl: '', thumbnailUrl: '' },
  },
}: IVideoMakerOpenerParams):
  | EmptyGenericScenarioParams
  | BasicGenericScenarioParams
  | EditScenarioParams {
  const {
    videoData,
    fileId,
    editScenarioFirstScreen,
    templateData,
    entityId,
    debug = false,
    template = Templates.Empty,
  } = extendedVideoMakerParams;

  const initialData = {
    locale,
    metaSiteId,
    opener: 'promote-video-home',
    origin: 'dashboard',
    siteMediaToken,
    userId,
    waitForVideoSavedToPrivateMedia: true,
  };

  if (fileId) {
    return {
      ...initialData,
      scenario: Scenarios.Edit,
      fileId,
      editScenarioFirstScreen,
    };
  }

  const commonData = {
    ...initialData,
    entityId,
    debug,
    scenario: Scenarios.Generic,
    template,
    videoData: {
      business: {},
      themeId: '207', // edgy, list of themes https://pix.wix.com/services/video-maker/music/themes
      trackId: '23470', // list of tracks https://pix.wix.com/services/video-maker/music/tracks/all
      script: VideoScripts.GENERAL_TEMPLATE,
      scriptData: {},
      sources: [],
      orientation: Orientations.Landscape,
      ...videoData,
    },
  };

  if (template === Templates.Empty) {
    return commonData as EmptyGenericScenarioParams;
  }

  return {
    ...commonData,
    templateData,
    template,
    videoData,
  } as BasicGenericScenarioParams;
}
